import * as React from "react"
import { cn } from "../../lib/utils"
export const baseInputStyles =
  "outline-0 flex h-10 w-full rounded-100 pl-3 pr-2 py-2 text-16 font-400 file:border-0 file:bg-transparent file:text-14 file:font-500 file:text-root-text-color-base placeholder:text-form-base-placeholder-default disabled:cursor-not-allowed disabled:opacity-50 tab:text-14"
const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          baseInputStyles,
          "border-1 bg-form-base-background text-root-text-color-base",
          // validation states
          "invalid:border-form-danger-border-default",
          "invalid:hover:border-form-danger-border-hover",
          "invalid:focus-visible:border-form-danger-border-hover",
          "invalid:hover:shadow-[0_0_0_4px_rgba(249,221,215,1)]",
          "invalid:focus-visible:shadow-[0_0_0_4px_rgba(249,221,215,1)]",
          // Default valid states
          "border-form-base-border-default hover:border-form-base-border-hover hover:shadow-[0_0_0_4px_rgba(243,245,246,1)] focus-visible:border-form-base-border-active focus-visible:shadow-[0_0_0_4px_rgba(255,242,229,1)]",
          "focus-visible:outline-none focus-visible:placeholder:text-form-base-placeholder-active",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export type PresentationInputProps = Omit<
  React.ButtonHTMLAttributes<HTMLButtonElement> & {
    children?: React.ReactNode
  },
  "value"
>

const PresentationInputButton = React.forwardRef<HTMLButtonElement, PresentationInputProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <button
        type="button"
        className={cn(
          "flex h-10 w-full rounded-100 border-1 border-form-base-border-default bg-form-base-background text-16 text-left text-root-text-color-base pl-3 pr-2 py-2 hover:bg-feedback-tertiary-background tab:text-14",
          className
        )}
        ref={ref}
        {...props}
      >
        {children}
      </button>
    )
  }
)
PresentationInputButton.displayName = "PresentationInput"

/**
 * Padding classes for the presentation input.
 *
 * @description
 * This is a utility class that is used to add padding to the presentation input if one needs it to be exact match with input.
 */
const presentation_input_padding_classes = "pl-3 pr-2 py-2"

/**
 * Skeleton loader for Input component that matches its dimensions exactly
 *
 */
function InputSkeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "animate-pulse flex h-10 w-full min-w-40",
        "rounded-2 bg-feedback-skeleton-background",
        className
      )}
      {...props}
    />
  )
}

export { Input, PresentationInputButton, presentation_input_padding_classes, InputSkeleton }
